import * as React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export interface OverlayLayoutProps {
  children: React.JSX.Element;
  onClick?: () => void;
}

export const OverlayLayout: React.FC<OverlayLayoutProps> = (props) => {
  return (
    <S.Container onClick={props.onClick}>
      <S.Center>{props.children}</S.Center>
    </S.Container>
  );
};
namespace S {
  const scale = keyframes`
    0%{
      transform: scale(0.9);
      opacity: 0;
    }
    100%{
      transform: scale(1);
      opacity: 1;
    }
  `;

  const fade = keyframes`
    0%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  `;

  export const Center = styled.div`
    animation: ${scale} 0.3s;
    animation-timing-function: cubic-bezier(0, 0.55, 0.45, 1);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 40px;
    z-index: 2;
    animation: ${fade} 0.3s;
    animation-timing-function: cubic-bezier(0, 0.55, 0.45, 1);
  `;
}
